<template>
  <v-container fluid class="mx-0 px-0" v-if="showRengiami">
    <h3 class="mb-3">{{ $t('Rengiami dokumentai') }}</h3>
    <v-data-table
      :loading="loading"
      :headers="filteredHeaders"
      :items="filterItemList"
      :search="search"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: this.$t('Rodyti po:'),
        itemsPerPageAllText: this.$t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
    >
      <template #[`item.dokumentas`]="{ item }">
        <v-row dense no-gutters>
          <v-col cols="12" md="12">
            <el-prasymas-busena
              class="my-1"
              :busena="item.pra_busena_pavadinimas"
            />
          </v-col>
          <v-col cols="12" md="12">
            <b>{{ item.pra_id }}</b>
          </v-col>
          <v-col cols="12" md="12">
            {{ item.pra_tipas_pavadinimas }}
          </v-col>
        </v-row>
      </template>
      <template #[`item.turtas`]="{ item }">
        <v-row dense no-gutters>
          <v-col
            v-for="turtas in item.turtai"
            :key="turtas[0]"
            class="mb-2"
            cols="12"
            md="12"
          >
            <div>{{ turtas[0] }}</div>
            <div>{{ turtas[1] }}</div>
          </v-col>
          <v-col cols="12" md="12" v-if="item.turtaiCut">
            ...
          </v-col>
        </v-row>
      </template>
      <template #[`item.pra_busenos_data`]="{ item }">
        <div class="nowrap center">{{ item.formatData }}</div>
        <div class="nowrap center">{{ item.formatLaikas }}</div>
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          :item="item"
          @editItem="editItem(item)"
          @viewItem="editItem(item)"
          @deleteItem="deleteItem(item)"
        />
        <el-button
          v-if="item.canPasirasyti"
          small
          :loading="loading"
          @click.native="pasirasytiItem(item)"
          >{{ $t('Pasirašyti') }}</el-button
        >
        <el-button
          v-if="item.canMoketi"
          small
          :loading="loading"
          @click.native="moketiItem(item)"
          >{{ $t('Mokėti') }}</el-button
        >
      </template>
      <template slot="loading">
        {{ $t('Kraunasi...') }}
      </template>
      <template slot="no-results">
        {{ $t('Duomenų nėra') }}
      </template>
      <template slot="no-data">
        {{ $t('Duomenų nėra') }}
      </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-delete
      :title="$t('Šalinti prašymą?')"
      :text="
        $t('Ar norite pašalinti prašymą') +
          ` <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalDelete from '../modals/ModalDelete'
import userRole from '@/mixins/userRole'
import busenaNtrTipas from '@/mixins/busenaNtrTipas'
import prasymasVeiksmas from '@/mixins/prasymasVeiksmas'

export default {
  name: 'PrasymasListRengiami',
  components: { ModalDelete },
  mixins: [userRole, busenaNtrTipas, prasymasVeiksmas],
  props: {
    prasymasTipasFilter: String,
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      prasymasLoading: false,
      showError: false,
      errorText: null,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      prasymas: [],
      searchData: {},
      itemsPerPageOptions: [10, 50, -1],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    ...mapGetters(['listInfo']),
    headers() {
      return [
        {
          text: this.$t('Dokumentas'),
          align: 'start',
          value: 'dokumentas',
          width: 190,
        },
        {
          text: this.$t('Dokumento šalis'),
          align: 'start',
          sortable: false,
          value: 'salis',
          hide: this.hideSalis,
        },
        {
          text: this.$t('Nekilnojamasis turtas'),
          align: 'start',
          sortable: false,
          value: 'turtas',
        },
        {
          text: this.$t('Data'),
          align: 'center',
          value: 'pra_busenos_data',
          width: 80,
        },
        {
          text: this.$t('Veiksmai'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 50,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    filterItemList() {
      return this.prasymas.map(prasymas => {
        prasymas.formatData = prasymas.pra_busenos_data.split(' ')[0]
        prasymas.formatLaikas = prasymas.pra_busenos_data.split(' ')[1]

        const maxTurtai = 3
        prasymas.turtaiCut = false
        if (prasymas.turtai.length > maxTurtai) {
          prasymas.turtai = prasymas.turtai.slice(0, maxTurtai)
          prasymas.turtaiCut = true
        }

        if (!this.iregistruoti) {
          prasymas.canView = prasymas.veiksmai.includes('savitarna-perziura')
          prasymas.canEdit = prasymas.veiksmai.includes('savitarna-redagavimas')
          prasymas.canDelete = prasymas.veiksmai.includes('savitarna-salinimas')

          prasymas.canPasirasyti = prasymas.veiksmai.includes(
            'savitarna-pasirasymas'
          )
          prasymas.canMoketi = prasymas.veiksmai.includes('savitarna-mokejimas')
        }

        if (prasymas.pra_busena === 'laukia_patvirtinimo') {
          prasymas.pra_busena_pavadinimas = this.$t('Laukia pasirašymo')
        }
        return prasymas
      })
    },
    prasymasTipas() {
      return this.prasymasTipasFilter
    },
    hideSalis() {
      return this.isPrasymasSeima || this.isPrasymasBendra
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    showRengiami() {
      return this.prasymas.length > 0
    },
  },
  created() {
    this.pageloading = true
    this.loading = true
    this.getData()
  },
  methods: {
    getData() {
      this.$axios
        .post(`ntrpaslaugos/rengiami-dokumentai/${this.prasymasTipasFilter}`)
        .then(res => {
          this.prasymas = res.data.prasymas
          this.pagination.total = this.prasymas.length
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.$emit('loaded', this.prasymas.length)
        })
    },
    editItem(item) {
      this.$emit('edit', item)
    },
    pasirasytiItem(item) {
      this.$emit('edit', item, true)
    },
    moketiItem(item) {
      this.moketiSavitarna(item.pra_id)
    },
    deleteItem(item) {
      this.modalDeleteVardas = `${item.pra_id}. ${item.pra_tipas_pavadinimas}`
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.confirmDeleteItem(item)
    },
    confirmDeleteItem(item) {
      this.$axios
        .delete(`ntrpaslaugos/prasymas/${item.pra_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.updateList()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    updateList() {
      // this.getData()
      this.$emit('updateList', this.prasymas.length)
    },
  },
}
</script>
<style lang="scss" scoped>
.duomenys {
  padding-top: 10px;
  padding-bottom: 10px;

  dl {
    display: flex;
    flex-flow: row wrap;
  }
  dt {
    flex-basis: 40%;
    padding: 2px 4px;
    text-align: right;
    font-weight: 400;
  }
  dd {
    flex-basis: 40%;
    flex-grow: 1;
    margin: 0;
    padding: 2px 4px;
    font-weight: 600;
  }
}
</style>
